export default {"src":"/_next/static/media/linked-wallets-bank-icon.c46b00c8.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};